import { defineStore } from 'pinia'
import tool from '@/utils/tool'

const defaultTags = [{ name: 'dashboard', title: '控制台', path: '/dashboard' }]

export default defineStore('tags', {
  state: () => ({
    tags: tool.local.get('tags') && tool.local.get('tags').length ? tool.local.get('tags') : defaultTags,
    refresh: true
  }),
  actions: {
    addTag(tag) {
      const result = this.tags.findIndex((item) => item.path === tag.path)
      if (result > -1) {
        return
      }
      this.tags.push({ name: tag.name, title: tag.name, path: tag.path })
      this.updateTagToLocal()
    },
    removeTag(tag) {
      const result = this.tags.findIndex((item) => item.path === tag.path)
      if (result > -1) {
        this.tags.splice(result, 1)
        this.updateTagToLocal()
      }
    },
    updateTagToLocal() {
      tool.local.set('tags', this.tags)
    },
    viewRefresh() {
      this.refresh = false
      setTimeout(() => {
        this.refresh = true
      }, 200)
    },
    reset() {
      this.$reset()
      console.log('this.tags :>> ', this.tags)
    }
  }
})
